<script setup lang="ts">
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'pejer/src/components/ui/accordion'
import { Separator } from 'pejer/src/components/ui/separator'
</script>
<template>
  <Accordion type="single" collapsible class="w-full">
    <AccordionItem value="item-1" class="border-none bg-slate-50 rounded-md">
      <AccordionTrigger class="px-2 rounded-md">Se steg-for-steg</AccordionTrigger>
      <AccordionContent>
        <div class="flex flex-col gap-6">
          <h3 class="text-xl font-semibold">Steg 1:</h3>
          <img src="/images/bank-integration/Step-1.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 2:</h3>
          <img src="/images/bank-integration/Step-2.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 3:</h3>
          <span>
            Velg et meningsfullt navn for kontoen. Navnet bør tydelig formidle at den er styrt av
            oss.<br />
            For eksempel: "<b>Oppgjørskonto - forvaltet</b>"
          </span>
          <img src="/images/bank-integration/Step-3.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 4:</h3>
          <img src="/images/bank-integration/Step-4.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 5:</h3>
          <img src="/images/bank-integration/Step-5.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 6:</h3>
          <span>
            Det tar rundt én bankdag før kontoen er registrert i systemet vårt, vennligst fortsett
            de neste stegene da.
          </span>
          <Separator />
          <h3 class="text-xl font-semibold">Steg 7:</h3>
          <img src="/images/bank-integration/Step-6.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 8:</h3>
          <img src="/images/bank-integration/Step-7.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 9:</h3>
          <img src="/images/bank-integration/Step-8.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 10:</h3>
          <img src="/images/bank-integration/Step-9.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 11:</h3>
          <img src="/images/bank-integration/Step-10.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 12:</h3>
          <img src="/images/bank-integration/Step-11.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 13:</h3>
          <img src="/images/bank-integration/Step-12.png" />
          <Separator />
          <h3 class="text-xl font-semibold">Steg 14:</h3>
          <img src="/images/bank-integration/Step-13.png" />
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
